/* ============
 * businessDays Transformer
 * ============
 */

import Transformer from './transformer';

export default class businessDaysTransformer extends Transformer {

  static fetch(businessDay) {
    return {
      id: businessDay.id,
      day: businessDay.day,
    };
  }

  static send(businessDay) {
    return {
      id: businessDay.id,
      day: businessDay.day,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/businessDay.js